import { createAxiosInstance } from '@client';
import {
  BaseQueryApi,
  BaseQueryFn,
  createApi
} from '@reduxjs/toolkit/dist/query/react';
import { AxiosRequestConfig, isAxiosError } from 'axios';
import { Messages } from '../../../sitemap/_common/messages/messages';
import { cloneDeep } from 'lodash';

const axiosBaseQuery: BaseQueryFn<
  {
    url: string;
    method: AxiosRequestConfig['method'];
    data?: AxiosRequestConfig['data'];
    params?: AxiosRequestConfig['params'];
    headers?: AxiosRequestConfig['headers'];
  },
  unknown,
  { status: number | undefined; data: any }
> = async ({ url, method, data, params, headers }, api: BaseQueryApi) => {
  // don't import RootState here! cyclic deps
  const state = api.getState() as {
    session: { authentication: { token: string } };
  };
  try {
    const axiosInstance = createAxiosInstance({
      token: state.session.authentication.token
    });

    const result = await axiosInstance({
      url,
      method,
      data,
      params,
      headers
    });

    return { data: result.data };
  } catch (err) {
    if (isAxiosError(err)) {
      const data = cloneDeep(err.response?.data);

      if (data?.message) data.message = Messages.parse(data.message);

      return {
        error: {
          status: err.response?.status,
          data
        }
      };
    } else {
      return {
        data: Messages.list().common.error.general
      };
    }
  }
};

export const mainRestApi = createApi({
  baseQuery: axiosBaseQuery,
  reducerPath: 'rest-api',
  endpoints: () => ({}),
  tagTypes: [
    'ADMIN_NOTES',
    'AGENT_PORT',
    'AGENT_PROFILE',
    'AGENT_PROFILE_PORTS',
    'AGENT_PROFILE_EXPERTISE',
    'APPOINTMENT',
    'EVALUATION',
    'APPOINTMENT_PROFORMA_TEMPLATE',
    'APPOINTMENT_PROFORMAS',
    'BANK_ACCOUNT',
    'BUYER_SETTINGS_BILLING_COMPANY',
    'BUYER_SETTINGS_HIDDEN_FIELDS',
    'BUYER_SETTINGS_PROFILE',
    'BUYER_SETTINGS_USER_PROFILE',
    'EXPENSE_GROUPS_HUSBANDRY',
    'POSITION_LIST_PORT_CALL',
    'PRICE_LISTS',
    'PRICE_LIST_DETAILS',
    'PRICE_LIST_DISCOUNT_DETAILS',
    'PROFORMA',
    'PORT_CALL_APPOINTMENTS',
    'REQUEST_CASE',
    'REQUEST_CASE_EVALUATE',
    'REQUEST_FOR_QUOTATION',
    'REQUEST_FOR_QUOTATION_EXPENSES',
    'REQUEST_FOR_QUOTATION_PRICELIST_AMOUNTS',
    'SUPPLIER_DETAILS',
    'SUPPLIER_LEGAL_ENTITY_DETAILS',
    'AGENT_COMPANY_DETAILS',
    'AGENT_PORT_ADDRESS',
    'AGENT_ADDITIONAL_INFO',
    'AGENT_CONSIGNEE',
    'AGENT_AOH_CONTACT',
    'AGENT_PORTS',
    'VESSEL_VOYAGES',
    'VESSEL_DETAILS',
    'BUYER_VOYAGE',
    'PORT_CALL',
    'VOYAGE_PORT_CALLS',
    'APPOINTMENT_EMAIL_CONFIGURATION',
    'PORT_CALL_COMMENT_HISTORY',
    'SUPPLIER_PORT_PRESENCE'
  ]
});
